export default __webpack_public_path__ + "static/media/favicon.fd8ef3da.ico";